
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Package } from "lucide-react";
import { EtsyProduct } from "@/hooks/useEtsyProducts";
import ProductsHeader from "./ProductsHeader";
import ProductsFiltersContainer from "./ProductsFiltersContainer";
import ProductGrid from "./ProductGrid";

interface ProductsMainContentProps {
  products: EtsyProduct[];
  isLoading: boolean;
  isConnected: boolean;
  needsOrderSync: boolean;
}

const ProductsMainContent = ({ 
  products, 
  isLoading, 
  isConnected, 
  needsOrderSync
}: ProductsMainContentProps) => {
  const [filteredProducts, setFilteredProducts] = useState<EtsyProduct[]>(products);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState<string | null>(null);

  const handleFilteredProductsChange = (filtered: EtsyProduct[], hasFilters: boolean) => {
    setFilteredProducts(filtered);
    setHasActiveFilters(hasFilters);
  };

  return (
    <div className="space-y-6">
      {needsOrderSync && (
        <Card className="border-orange-200 bg-orange-50">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <Package className="h-5 w-5 text-orange-600 mt-0.5" />
              <div>
                <h3 className="font-semibold text-orange-900">Sales Data Missing</h3>
                <p className="text-orange-800 text-sm mt-1">
                  Your products are showing 0 sales because order data hasn't been synced yet. 
                  Click "Sync Orders" above to import your Etsy orders and see accurate sales counts.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      <ProductsHeader products={products} />

      <ProductsFiltersContainer 
        products={products}
        onFilteredProductsChange={handleFilteredProductsChange}
      />

      <ProductGrid
        products={filteredProducts}
        isLoading={isLoading}
        hasActiveFilters={hasActiveFilters}
        onProductSelect={setSelectedProductId}
      />
    </div>
  );
};

export default ProductsMainContent;
